import gql from 'graphql-tag';
import userInfoFragment from '../user/userInfo';
import communityInfoFragment from '../community/communityInfo';

import communityMetaDataFragment from '../community/communityMetaData';

import threadParticipantFragment from './threadParticipant';
import channelInfoFragment from '../channel/channelInfo';

export default gql`
  fragment threadInfo on Thread {
    id
    messageCount
    createdAt
    modifiedAt
    lastActive
    receiveNotifications
    currentUserLastSeen
    editedBy {
      ...threadParticipant
    }
    author {
      ...threadParticipant
    }
    community {
      ...communityInfo
      ...communityMetaData
    }
    isPublished
    isLocked
    isAuthor
    type
    content {
      title
      body
    }
    attachments {
      attachmentType
      data
    }
    watercooler
    metaImage
    reactions {
      count
      hasReacted
    }
    experts {
      id
      name
      profilePhoto
      username
      firstName
      lastName
      lastActive
      isOnline
      isExpert
    }
    postType
  }
  ${threadParticipantFragment}
  ${userInfoFragment}
  ${communityInfoFragment}
  ${communityMetaDataFragment}
`;
